export default "__VITE_ASSET__2ngJ4feX__"